import { css } from "@conectate/components/ct-lit";

export const litStyles = [
	css`
		.page-content {
			max-width: 1550px;
			margin: 0 auto;
			padding: 8px 16px 64px;
		}

		[disabled] {
			cursor: not-allowed;
			pointer-events: none;
			opacity: 0.33;
		}
		[data-b],
		[data-break-before] {
			page-break-before: always;
			break-before: page;
		}
		[data-a],
		[data-break-after] {
			page-break-after: always;
			break-after: page;
		}
		[data-i],
		[data-break-inside-avoid] {
			page-break-inside: avoid;
			break-inside: avoid;
		}
	`,
	css`
		.card-head {
			display: flex;
			align-items: center;
			padding: 32px 24px;
			border-bottom: 1px solid var(--color-outline);
		}
		.card-head > h2 {
			margin: 0;
			color: var(--color-on-surface);
		}
	`,
	css`
		*,
		*:before,
		*:after {
			box-sizing: border-box;
			-moz-osx-font-smoothing: grayscale;
			-webkit-font-smoothing: antialiased;
			/* outline: 1px dotted #bababa; */
			/* vertical-align: middle; */
		}
		.highlight-font {
			font-display: swap;
			font-family: "Google Sans", "Ubuntu", arial, sans-serif;
		}

		hr.x {
			flex-grow: 1;
			border: 0;
			border-bottom: 1px solid var(--color-outline);
			max-width: 152px;
			margin: auto 0;
		}
		hr {
			margin: auto 0;
			height: 1px;
			background: var(--color-border, #8383835a);
			border: none;
			flex-grow: 1;
			border: 0;
		}
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			font-display: swap;
			font-family: var(--font-title, "Google Sans", "Ubuntu", arial, sans-serif);
		}
		h1,
		h2,
		h3,
		h4 {
			color: var(--color-primary);
			/* margin-top: 0.8em;
		margin-bottom: 0.8em; */
		}

		.label {
			font-family: var(--font-title, "Google Sans", "Ubuntu", arial, sans-serif);
			font-size: 0.7rem;
			font-weight: 500;
			letter-spacing: 0.00625rem;
			line-height: 1rem;
			color: var(--medium-emphasis);
			text-transform: uppercase;
		}

		a {
			color: var(--color-primary);
			text-decoration: none;
			transition: border-color var(--animation);
		}

		.pre-t {
			margin-top: 0;
			margin-bottom: 40px;
			color: var(--color-primary);
			font-size: 13px;
			font-weight: 500;
			text-align: center;
			letter-spacing: 6px;
			text-transform: uppercase;
		}
		.t-1 {
			font-size: 1.5em;
			margin: 0.67em 0 0 0;
		}
		.t-1:before {
			background-image: var(--color-app);
			display: block;
			content: "";
			width: 1.4em;
			height: 2px;
			margin: 0.5em 0;
		}

		.t-2 {
			font-size: 1.3em;
			margin: 0 0 0.67em 0;
			font-weight: normal;
		}

		.t-3 {
			font-weight: normal;
			font-size: 1.3em;
		}
		.t-3:before {
			background-image: var(--color-app);
			display: block;
			content: "";
			width: 2.25em;
			height: 2px;
			margin: 0.7em 0;
		}

		blockquote {
			margin: 0 0 16px;
			border-left: 0.25em solid #dfe2e5;
			color: var(--medium-emphasis, #6a737d);
			padding: 0 1em;
			margin: 16px 0;
		}

		code {
			font-size: 0.85em;
			padding: 4px;
			background: #7b7b7b26;
			border-radius: 8px;
			white-space: break-spaces;
			word-break: break-all;
			text-align: left;
			display: inline-block;
		}
		pre {
			font-size: 0.9em;
			background-color: #7b7b7b26;
			overflow: auto;
			padding: 8px;
			border-radius: 8px;
		}
		pre code {
			font-size: inherit;
			padding: 0;
			background: none;
		}

		.menu {
			padding-right: 4px;
		}
		.menu ct-button-menu {
			border-left: 1px solid #80808076;
			margin-left: 8px;
		}

		[hidden] {
			display: none !important;
		}
		[show],
		[data-show] {
			display: block !important;
		}
		[show-flex],
		[data-show-flex] {
			display: flex !important;
		}
		[fit] {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
		}

		[scroll] {
			-webkit-overflow-scrolling: touch;
			scroll-behavior: smooth;
			overflow: auto;
		}
		.hx-t1 {
			margin: 0px;
			font-weight: 700;
			font-size: 1.5em;
			line-height: 1.375;
		}
		@media (min-width: 1200px) {
			.hx-t1 {
				font-size: 2em;
			}
		}
		@media only print {
			.no-print,
			ct-button {
				display: none !important;
			}
		}
	`,
	css`
		@keyframes pulse {
			0% {
				box-shadow: 0 0 0 0 var(--color-primary-medium);
			}
			100% {
				box-shadow: 0 0 0 45px #2cb6e800;
			}
		}

		@keyframes pause {
			from {
				box-shadow: 0 0 0 45px #2cb6e800;
			}
			to {
				box-shadow: 0 0 0 45px #2cb6e800;
			}
		}
		@keyframes shine {
			0% {
				background-position: 200% 0;
			}

			100% {
				background-position: -200% 0;
			}
		}

		.pulse {
			box-shadow: 0 0 0 0 var(--color-primary-medium);
			animation: pulse 1.25s cubic-bezier(0.66, 0, 0, 1) infinite;
		}

		.pulse:hover {
			animation: none;
		}

		.make-shine {
			-webkit-background-clip: text;
			background-clip: text;
			background-size: 200% 100%;
			-webkit-text-fill-color: transparent;
			animation: shine 2s linear infinite;
		}
		.make-shine {
			background-image: linear-gradient(
				90deg,
				color-mix(in srgb, var(--medium-emphasis) 60%, transparent) 0,
				color-mix(in srgb, var(--medium-emphasis) 60%, transparent) 25%,
				var(--high-emphasis) 60%,
				color-mix(in srgb, var(--medium-emphasis) 60%, transparent) 75%,
				color-mix(in srgb, var(--medium-emphasis) 60%, transparent) 100%
			);
		}
	`
];

export const tableStyles = css`
	.table-container {
		border: 1px solid var(--color-outline);
		border-radius: var(--border-radius);
		margin-bottom: 32px;
	}

	table {
		min-width: 100%;
		border-collapse: collapse;
		border-spacing: 0px;
	}
	tbody {
		background-color: var(--color-surface-bright);
		/* border: 1px solid #4c608347; */
	}

	thead,
	.thead,
	tfoot,
	.tfoot {
		position: sticky;
		top: 0;
		/* display: table-header-group; */
		border-bottom: none;
		background-color: var(--color-surface-dim);
		z-index: 5;
	}
	tr,
	.tr {
		color: inherit;
		vertical-align: middle;
		outline: 0px;
		background-color: transparent;
		transition: background-color 150ms;
	}
	tr:hover,
	.tr:hover {
		background-color: #b3b3b31a;
	}
	th,
	.th {
		font-family:
			Inter,
			-apple-system,
			BlinkMacSystemFont,
			"Roboto",
			Helvetica,
			Arial,
			sans-serif,
			"Apple Color Emoji",
			"Segoe UI Emoji";
		/* display: table-cell; */
		vertical-align: inherit;
		text-align: left;
		padding: 15px 16px;
		font-size: 0.8em;
		border-bottom: none;
		font-weight: 600;
		letter-spacing: 0.5px;
		text-transform: uppercase;
	}
	td,
	.td {
		font-size: 0.9em;
		font-weight: 400;
		line-height: 1.4;
		min-width: 36px;
		padding: 12px 16px;
		border-bottom: 1px solid var(--color-outline);
	}
	tr:last-child td {
		border-bottom: none;
	}

	th:first-child,
	.th:first-child {
		border-top-left-radius: var(--border-radius);
	}
	th:last-child,
	.th:last-child {
		border-top-right-radius: var(--border-radius);
	}

	/* tfoot */

	tfoot tr:last-child td:first-child {
		border-bottom-left-radius: var(--border-radius);
	}
	tfoot tr:last-child td:last-child {
		border-bottom-right-radius: var(--border-radius);
	}

	tbody:last-child tr:last-child td:first-child {
		border-bottom-left-radius: var(--border-radius);
	}
	tbody:last-child tr:last-child td:last-child {
		border-bottom-right-radius: var(--border-radius);
	}

	td.actions,
	th.actions {
		text-align: right;
		flex-direction: row-reverse;
	}
`;
